import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CTA, Icon, Text } from '../../../atoms';
import ButtonsBanner from '../ButtonsBanner';
import {
  ADD_SECTION,
  COURSE_TAB_SAVE,
  TUTOR_DISABLED_TAB_SET,
} from '../../../../app/redux/actions/tutors';
import routes from '../../../../routes';
import { CustomBox, Separator, Warning } from '../style';
import { ActivitiesContainer } from './style';
import ModalCreateQuiz from '../../../atoms/Modals/ModalCreateQuiz';
import ModalPreviewQuiz from '../../../atoms/Modals/ModalPreviewQuiz';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import theme from '../../../theme';
import SessionBox from '../../../atoms/SessionBox';
import ModalCreateSession from '../../../atoms/Modals/ModalCreateSession';

const SessionsTab = ({
  mediaIsPhone,
  setDisabledTab,
  activeTab,
  sections,
  addSection,
  courseTabSave,
}) => {
  const isValidSections = (sects = []) => {
    const quizes = sects.map((s) =>
      Object.values(s?.activities || {}).find(
        (act) => act?.type === 'activity_quiz'
      )
    );

    let isValid = true;
    if (quizes?.findIndex((q) => q === undefined) >= 0) isValid = false;
    if (sects?.findIndex((s) => !s?.title) >= 0) isValid = false;
    return isValid;
  };
  const isValidActivities = (activities = []) => {
    let isValid = true;
    if (activities?.length < 2) return false;
    activities.forEach((a) => {
      if (!a?.type) isValid = false;
      if (Object.keys(a?.data || {})?.length <= 0) isValid = false;
    });
    return isValid;
  };

  useEffect(() => {
    const sects = Object.values(sections || {});
    const activities = [];
    sects.forEach((s) => activities.push(...Object.values(s.activities)));

    if (isValidSections(sects) && isValidActivities(activities)) {
      setDisabledTab({
        2: { completed: true },
        3: { disabled: false },
        4: { disabled: false },
      });
    } else {
      setDisabledTab({
        2: { completed: false },
        3: { disabled: true },
        4: { disabled: true },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections]);

  useEffect(() => {
    return () => {
      if (activeTab === 2) {
        courseTabSave({
          tabName: 'activities',
          data: { sections },
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, sections]);

  return (
    <ActivitiesContainer>
      <div className={mediaIsPhone ? '' : 'd-flex sb title-wrapper'}>
        <Text type="b3" mb={mediaIsPhone ? 16 : 0}>
          Sezione dedicata all’aggiunta delle attività per il discente. Per
          procedere con la creazione del percorso formativo è necessario
          inserire massimo 2 attività.
        </Text>
        <CTA
          btnText="catalogo attività"
          type="tertiary"
          icon="link-external-02"
          onClick={() =>
            window.open(
              `${window.location.origin}${routes.scormList.path}`,
              '_blank'
            )
          }
        />
      </div>
      <Separator />
      {Object.keys(sections).map((k, i) => (
        <SessionBox key={`section-${i + 1}`} index={i + 1} sectionKey={k} />
      ))}
      <CustomBox>
        <CTA
          type="tertiary"
          btnText="Aggiungi altra sessione"
          icon="plus"
          onClick={addSection}
        />
      </CustomBox>
      {mediaIsPhone && (
        <>
          <Text type="b3" className="mt-5" mb={24} color={theme().colors.fail}>
            * campo obbligatorio
          </Text>
          <Warning>
            <Icon type="alert-circle" size={16} />
            <Text type="b4" className="warning d-flex align-start">
              Per procedere con la creazione del percorso formativo è necessario
              inserire almeno 2 attività in totale all’interno di una o più
              sezioni
            </Text>
          </Warning>
        </>
      )}
      <ButtonsBanner
        hasMandatoryFields
        warning="Per procedere con la creazione del percorso formativo è necessario inserire almeno 2 attività in totale all’interno di una o più sezioni"
      />
      <ModalCreateQuiz isEvent />
      <ModalPreviewQuiz isEvent />
      <ModalCreateSession />
    </ActivitiesContainer>
  );
};

SessionsTab.propTypes = {
  mediaIsPhone: PropTypes.bool,
  setDisabledTab: PropTypes.func,
  sections: PropTypes.object,
  activeTab: PropTypes.number,
  addSection: PropTypes.func,
  courseTabSave: PropTypes.func,
};

export default connect(
  (state) => {
    const { sections } = state.tutors.activities;
    const { activeTab } = state.tutors;
    return { sections, activeTab };
  },
  (dispatch) => ({
    setDisabledTab: (tabs) => dispatch({ type: TUTOR_DISABLED_TAB_SET, tabs }),
    addSection: () => dispatch({ type: ADD_SECTION }),
    courseTabSave: ({ tabName, data }) =>
      dispatch({ type: COURSE_TAB_SAVE, tabName, data }),
  })
)(withMediaQueries(SessionsTab));
